module.exports = __webpack_public_path__ + "static/media/perc2.2e966ac3.ogg";